import React, { useState } from 'react';
import * as Bixby from '$/core';
import classnames from 'classnames';
import { ReactComponent as Chevron } from '$/assets/icons/Chevron.svg';

interface IUserGuideItemProps {
  type: Bixby.Enums.HelpCenterItemType;
  title: string;
  userGuides: Bixby.Models.HelpCenterItem[];
  onDownloadClick: (id: string) => Promise<void> | void;
}

const UserGuideItem: React.FC<IUserGuideItemProps> = props => {
  const { title, userGuides, onDownloadClick } = props;
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="user-guide-category">
      <h2 onClick={() => setExpanded(!expanded)} className={classnames({ expanded })} role="button">
        <span>{title}</span>
        <Chevron className={classnames('expand hide_print', { expanded })} />
      </h2>
      {expanded && (
        <div className="overflow-control">
          <div className="user-guides-list" role="list">
            {userGuides.map((_, ix) => (
              <div role="listitem" className="list-item" key={ix}>
                <div className="fake-link" onClick={() => onDownloadClick(_.id)} role="button">
                  {_.title}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default UserGuideItem;
